// Glyphs stroke `currentColor` so the card controls their colour.
export default function ToolIcon({ type }) {
  const s = {
    width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
    strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true,
  };
  if (type === 'db') return (
    <svg {...s}>
      <ellipse cx="12" cy="5" rx="8" ry="3"/>
      <path d="M20 5v14c0 1.66-3.58 3-8 3s-8-1.34-8-3V5"/>
      <path d="M20 12c0 1.66-3.58 3-8 3s-8-1.34-8-3"/>
    </svg>
  );
  if (type === 'users') return (
    <svg {...s}>
      <circle cx="10" cy="8" r="4.5"/><path d="M2.5 21a8 8 0 0 1 12.4-6.1"/>
      <path d="M19 15.5v6"/><path d="M22 18.5h-6"/>
    </svg>
  );
  if (type === 'clients') return (
    <svg {...s}>
      <path d="M3 21V6l7-3v18"/><path d="M10 21V11l11 3.5V21"/>
      <path d="M2 21h20"/><path d="M6.5 8.5h.01"/><path d="M6.5 13h.01"/><path d="M14.5 17.5h2"/>
    </svg>
  );
  if (type === 'build') return (
    <svg {...s}>
      <rect x="2.5" y="4" width="19" height="16" rx="2"/>
      <path d="M9 10.5 6.5 12.5 9 14.5"/><path d="M15 10.5 17.5 12.5 15 14.5"/>
      <path d="M12.8 9.5 11.2 15.5"/>
    </svg>
  );
  if (type === 'tasks') return (
    <svg {...s}>
      <rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9h10"/><path d="M7 13h6"/>
    </svg>
  );
  if (type === 'reach') return (
    <svg {...s}><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/></svg>
  );
  if (type === 'paid') return (
    <svg {...s}>
      <rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="M6 14.5h4"/>
    </svg>
  );
  if (type === 'tag') return (
    <svg {...s}>
      <path d="M12.6 2.6A2 2 0 0 0 11.2 2H4a2 2 0 0 0-2 2v7.2a2 2 0 0 0 .6 1.4l8.7 8.7a2.4 2.4 0 0 0 3.4 0l6.6-6.6a2.4 2.4 0 0 0 0-3.4z"/>
      <path d="M7.5 7.5h.01"/>
    </svg>
  );
  if (type === 'chart') return (
    <svg {...s}><path d="M3 16.5l5.5-5.5 3.5 3.5L21 5.5"/><path d="M15.5 5.5H21v5.5"/></svg>
  );
  if (type === 'statex') return (
    <svg {...s}><path d="M6 20V11"/><path d="M12 20V4"/><path d="M18 20v-6"/></svg>
  );
  return (
    <svg {...s}><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/></svg>
  );
}

